




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";
import { Const } from "@/const";
// TODO document2
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { SimpleTextLayer } from "@/model/document2/page/surface/design/layer/simpleTextLayer";
import { TextInfo } from "@/utilityModels/textInfo";
import { UnitHelper } from "@/helper/unitHelper";
import { MathHelper } from "@/helper/mathHelper";
import { UuidHelper } from "@/helper/uuidHelper";
import { StringHelper } from "@/helper/stringHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { FontManager } from "@/model/fontManager/fontManager";
import { DebugHelper } from "@/helper/debugHelper";
import { SimpleTextLayerHelper } from "@/helper/simpleTextLayerHelper";

import { Rectangle } from "@/utilityModels/rectangle";
import { FontFamily } from "../../../../../model/fontManager/fontFamily/fontFamily";
import { Vector2 } from "../../../../../utilityModels/vector2";

@Component({
  components: {}
})
export default class SimpleTextLayerDrawerB extends Vue {
  // プレースホルダー
  static readonly PLACEHOLDER_OPACITY = 0.5;
  // 文字の高さに対する下線の割合
  static readonly UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT = 1 / 22.0;
  // 文字の高さに対する下線までのスペース
  static readonly UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT = 4 / 22.0;

  @Prop() private layer!: SimpleTextLayer;
  @Prop() private scale!: number;
  @Prop() private offsetX!: number;
  @Prop() private offsetY!: number;
  @Prop() private isRendering!: boolean;
  @Prop() private isRenderingOnClient!: boolean;
  // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
  @Prop({ default: false }) private isInEditor!: boolean;

  private uuid = "";

  // 行ごとの文字の表示領域を保持する
  static readonly CALC_BASE_FONT_SIZE = 14.0;
  private lineRectsInfoCache : { [key: string]: any; } = {};
  private clearLineRectsInfoCache() { this.lineRectsInfoCache = {}; }
  private getLineRectsInfo(line : string, fontSize : number) {
    let fontManager: FontManager = this.$store.getters.fontManager;
    let fontFamily = fontManager.getSimpleTextFontFamilyName(this.layer.baseTextInfo.fontId, false);
    let baseFontSize = SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE;
    if(!(line in this.lineRectsInfoCache)) {
      let rectsInfo = StringHelper.calcLineRects(
        line,
        baseFontSize, 
        fontFamily,
        this.getFontWeight(),
        this.getFontStyle()
      );
      this.lineRectsInfoCache[line] = rectsInfo;
    }
    let cache = this.lineRectsInfoCache[line];
    let rects : Array<any> = [];
    let scale = fontSize / baseFontSize;
    for(let i = 0; i < cache.rects.length; ++i) {
      rects.push({
        "x" : cache.rects[i].x * scale,
        "y" : cache.rects[i].y * scale,
        "width" : cache.rects[i].width * scale,
        "height" : cache.rects[i].height * scale
      });
    }
    return { "rects": rects };
  }


  // 各文字のサイズを保持する(フォントサイズ14を基準とする)
  private textSizeCache : { [key: string]: any; } = {};
  private clearTextSizeCache() { this.textSizeCache = {}; }
  private generateTextSizeCache()
  {
    if(Object.keys(this.textSizeCache).length > 0) return;
    let allText = this.layerText.replace(/\r?\n/g, '');
    let fontManager: FontManager = this.$store.getters.fontManager;
    let fontFamily = fontManager.getSimpleTextFontFamilyName(this.layer.baseTextInfo.fontId, false);
    for(let i = 0; i < allText.length; ++i)
    {
      let text = allText[i];
      if(!(text in this.textSizeCache))
      {
        let size = StringHelper.calcTextSizeOnSVGPt(
          text, 
          SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE, 
          fontFamily,
          this.getFontWeight(),
          this.getFontStyle(),
          false);
        this.textSizeCache[text] = size;
      }
    }
  }
  private getTextSize(text : string, fontSize : number)
  {
    let fontManager: FontManager = this.$store.getters.fontManager;
    let fontFamily = fontManager.getSimpleTextFontFamilyName(this.layer.baseTextInfo.fontId, false);
    if(!(text in this.textSizeCache))
    {
      let size = StringHelper.calcTextSizeOnSVGPt(
        text, 
        SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE, 
        fontFamily,
        this.getFontWeight(),
        this.getFontStyle(),
        false);
      this.textSizeCache[text] = size;
    }
    let cacheSize = this.textSizeCache[text];
    return {
      "width": cacheSize.width * fontSize / SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE,
      "height": cacheSize.height * fontSize / SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
    };
  }

  // 各行のサイズを保持する(フォントサイズを14とする)
  private lineSizeCache : { [key: string]: any; } = {}; // 通常キャッシュ
  private lineSizeCacheFixedSize : { [key: string]: any; } = {}; // フォントサイズ固定のキャッシュ(簡易表示)
  private clearLineSizeCache() { this.lineSizeCache = {}; }
  private clearLineSizeCacheFixedSize() { this.lineSizeCacheFixedSize = {}; }
  private getLineSize(text : string, fontSize : number)
  {
    let fontManager: FontManager = this.$store.getters.fontManager;
    let fontFamily = fontManager.getSimpleTextFontFamilyName(this.layer.baseTextInfo.fontId, false);
    if(this.$store.getters.applicationState.moveLayerMode != 0)
    {
      // 移動・拡大縮小・回転中であれば簡易版キャッシュを使う
      // フォントサイズはあとからスケールする
      DebugHelper.trace("簡易キャッシュ. text = " + text);
      if(!(text in this.lineSizeCacheFixedSize))
      {
        //! フォントウェイト、フォントスタイルは無視する
        //! 互換性のため...
        let size = StringHelper.calcTextSizeOnSVGPt(
          text, 
          SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE, 
          fontFamily);
        DebugHelper.trace(size);
        this.lineSizeCacheFixedSize[text] = size;
      }
      let cacheSize = this.lineSizeCacheFixedSize[text];
      return {
        "width": cacheSize.width * fontSize / SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE,
        "height": cacheSize.height * fontSize / SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
      };
    } else {
      // 通常キャッシュを使う
      // フォントサイズが変わったら変更される
      if(!(text in this.lineSizeCache))
      {
        //! フォントウェイト、フォントスタイルは無視する
        //! 互換性のため...
        let size = StringHelper.calcTextSizeOnSVGPt(
          text, 
          fontSize, 
          fontFamily);
        this.lineSizeCache[text] = size;
      }
      return this.lineSizeCache[text];
    }
  }

  @Watch("layer.x")
  onXChanged(val: number, oldVal: number) {
    this.updateLineInfoArray();
  }

  @Watch("layer.y")
  onYChanged(val: number, oldVal: number) {
    this.updateLineInfoArray();
  }

  @Watch("layer.width")
  onWidthChanged(val: number, oldVal: number) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.height")
  onHeightChanged(val: number, oldVal: number) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.text")
  onTextChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.clearLineSizeCache();
    this.clearLineSizeCacheFixedSize();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.autoLineText")
  onAutoLineTextChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearLineSizeCache();
    this.clearLineSizeCacheFixedSize();
    this.updateLineInfoArray();
  }

  @Watch("layer.inEdit")
  onInEditChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.clearLineSizeCache();
    this.clearLineSizeCacheFixedSize();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.fontSize")
  onFontSizeChanged(val, oldVal) {
    this.clearLineSizeCache();
    this.updateLineInfoArray();
    this.updateLineInfoArray();
  }

  @Watch("layer.autoFontSize")
  onAutoFontSizeChanged(val, oldVal) {
    this.clearLineSizeCache();
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.fontId")
  onFontIdChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.clearLineSizeCache();
    this.clearLineSizeCacheFixedSize();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.letterSpacing")
  onLetterSpacingChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.letterWidth")
  onLetterWidthChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.bold")
  onBoldChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.italic")
  onItalicChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.lineSpacing")
  onLineSpacingChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.autoSize")
  onAutoSizeChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.autoNewLine")
  onAutoNewLineChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.prefix")
  onPrefixChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.clearLineSizeCache();
    this.clearLineSizeCacheFixedSize();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.suffix")
  onSuffixChanged(val, oldVal) {
    this.clearLineRectsInfoCache();
    this.clearTextSizeCache();
    this.clearLineSizeCache();
    this.clearLineSizeCacheFixedSize();
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateLineInfoArray();
  }

  @Watch("layer.horizontalAlignment")
  onHorizontalAlignmentChanged(val, oldVal) {
    this.updateLineInfoArray();
  }

  @Watch("layer.verticalAlignment")
  onVerticalAlignmentChanged(val, oldVal) {
    this.updateLineInfoArray();
  }

  @Watch("layer.baseTextInfo.isEmQuad")
  onIsEmQuadChanged(val, oldVal) {
    this.updateLineInfoArray();
  }

  private updateAutoFontSizeIfNeeded() {
    // テキスト編集中は更新しない
    if (this.layer.inEdit) return;
    // デザイン編集画面では編集面選択で更新しない
    if (!this.isInEditor && this.$route.path == "/DesignEditor") return;

    this.updateAutoFontSize();
  }

  private updateAutoFontSize() {
    if (this.layer.autoSize && !this.layer.autoNewLine) {
      var text = this.layerText;
      this.layer.autoFontSize = SimpleTextLayerHelper.calcAutoSize(
        text,
        this.$store.getters.fontManager,
        this.layer.baseTextInfo.fontId,
        this.layer.baseTextInfo.letterSpacing,
        this.layer.baseTextInfo.letterWidth,
        this.layer.lineSpacing,
        this.layer.width,
        this.layer.height,
        this.getFontWeight(),
        this.getFontStyle(),
        this.lineSizeCacheFixedSize,
        SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
      );

      DebugHelper.trace(
        "updateAutoFontSizeIfNeeded : " + this.layer.autoFontSize
      );
    }
  }

  private updateAutoNewLineFontSizeIfNeeded() 
  {
    if (this.layer.autoNewLine)
    {
      if (this.layer.autoSize) 
      {
        // テキスト編集中は更新しない
        if (this.layer.inEdit) return;
        // デザイン編集画面では編集面選択で更新しない
        if (!this.isInEditor && this.$route.path == "/DesignEditor") return;
        this.updateAutoNewLineFontSize();
      }
      else
      {
        // テキスト編集中は更新しない
        if (this.layer.inEdit) return;
        // デザイン編集画面では編集面選択で更新しない
        if (!this.isInEditor && this.$route.path == "/DesignEditor") return;
        this.updateAutoNewLine();
      }
    }
  }

  private updateAutoNewLineFontSize()
  {
    this.generateTextSizeCache();
    let text = this.layerText;
    let result = SimpleTextLayerHelper.calcAutoLineSize(
      text,
      this.$store.getters.fontManager,
      this.layer.baseTextInfo.fontId,
      this.layer.baseTextInfo.letterSpacing,
      this.layer.baseTextInfo.letterWidth,
      this.layer.lineSpacing,
      this.layer.width,
      this.layer.height,
      this.getFontWeight(),
      this.getFontStyle(),
      false,
      this.textSizeCache,
      SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
    );
    this.layer.autoFontSize = result.fontSize;
    this.layer.autoLineText = result.autoLineText;

    DebugHelper.trace(
      "updateAutoNewLineFontSizeIfNeeded : " + this.layer.autoFontSize
    );
    DebugHelper.trace(result.autoLineText);
  }

  private updateAutoNewLine()
  {
    this.generateTextSizeCache();
    let text = this.layerText;
    let lines = SimpleTextLayerHelper.getAutoLineTextWithFixedFontSize(
      text,
      this.$store.getters.fontManager,
      this.layer.baseTextInfo.fontSize,
      this.layer.baseTextInfo.fontId,
      this.layer.baseTextInfo.letterSpacing,
      this.layer.baseTextInfo.letterWidth,
      this.layer.lineSpacing,
      this.layer.width,
      this.layer.height,
      this.getFontWeight(),
      this.getFontStyle(),
      false,
      this.textSizeCache,
      SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
    );
    this.layer.autoLineText = lines;
      DebugHelper.trace(
      "getAutoLineTextWithFixedFontSize"
    );
    DebugHelper.trace(lines);
  }

  private updateEdittingTextIfNeeded()
  {
    if(this.layer.inEdit)
    {
      let lines = SimpleTextLayerHelper.getAutoLineTextWithFixedFontSize(
        this.layer.text,
        this.$store.getters.fontManager,
        this.layer.autoSize ? this.layer.autoFontSize : this.layer.baseTextInfo.fontSize,
        this.layer.baseTextInfo.fontId,
        this.layer.baseTextInfo.letterSpacing,
        this.layer.baseTextInfo.letterWidth,
        this.layer.lineSpacing,
        this.layer.width,
        this.layer.height,
        this.getFontWeight(),
        this.getFontStyle(),
        false
      );
      this.layer.edittingText = lines;
    }
  }

  mounted() {
    this.uuid = UuidHelper.getUuid();

    if (this.layer.autoFontSize <= 0) {
      // 強制的に自動サイズ更新
      this.updateAutoFontSize();
      this.updateAutoNewLineFontSize();
    } else {
      this.updateAutoFontSizeIfNeeded();
      this.updateAutoNewLineFontSizeIfNeeded();
    }
    this.updateLineInfoArray();
  }

  private get isVisibleBySystem() {
    // エディット対象以外かつ、文字列が空なら表示しない
    return this.isInEditor || this.layer.text != "";
  }

  private getFontSizeMm() {
    var fontSize = this.layer.autoSize
      ? this.layer.autoFontSize
      : this.layer.baseTextInfo.fontSize;
    return UnitHelper.convert(fontSize, "pt", "mm");
  }

  private get x() {
    return this.layer.x;
  }

  private get y() {
    return this.layer.y;
  }

  private get opacity() {
    return this.layer.text == ""
      ? SimpleTextLayerDrawerB.PLACEHOLDER_OPACITY
      : this.layer.opacity / 100;
  }

  private get layerText() {
    var text = "";
    if (this.layer.inEdit) {
      // テキスト編集中はプレースホルダ、語頭語尾を表示しない
      text = this.layer.text;
    } else if (!this.isInEditor && this.isRendering) {
      // レンダリング時とエディタ以外はプレースホルダを表示しない
      text =
        this.layer.text == ""
          ? ""
          : this.layer.prefix + this.layer.text + this.layer.suffix;
      // 全角対応
      if (this.layer.baseTextInfo.isEmQuad)
        text = StringHelper.toEmQuadString(text);
    } else {
      text =
        this.layer.text == ""
          ? "文字を入力"
          : this.layer.prefix + this.layer.text + this.layer.suffix;
      // 全角対応
      if (this.layer.baseTextInfo.isEmQuad)
        text = StringHelper.toEmQuadString(text);
    }

    return text;
  }

  private lineInfoArray : Array<{
    x: number;
    xs: string;
    y: number;
    width: number;
    height: number;
    text: string;
  }> = [];
  private updateLineInfoArray() {
    var array: Array<any> = [];
    // 改行コードで分離
    var renderingText =
      this.layer.autoNewLine && this.layer.autoLineText.length > 0
        ? this.layer.autoLineText
        : this.layerText;
    if (this.isInEditor && this.layer.inEdit) renderingText = this.layer.edittingText;
    var lines = renderingText.split("\n");
    // 字間
    var letterSpacing = UnitHelper.convert(
      this.layer.baseTextInfo.letterSpacing,
      "pt",
      "mm"
    );
    letterSpacing *= 100 / this.layer.baseTextInfo.letterWidth;
    // 各行について情報を生成する
    // 基準位置
    var basex = this.layer.x;
    var basey = this.layer.y;
    var curx = basex;
    var cury = basey;
    var fontSize = this.getFontSizeMm();
    for (var i = 0; i < lines.length; ++i) {
      var line = lines[i];
      let xs : number[] = [];
      let lineWidth = 0;
      let lineHeight = 0;
      if(line.length > 0) 
      {
        let lineRectsInfo = this.getLineRectsInfo(line, fontSize);
        for (let cIdx = 0; cIdx < line.length; ++cIdx)
        {
            let charax = cIdx < lineRectsInfo.rects.length ? lineRectsInfo.rects[cIdx].x + curx : curx;
            xs.push(charax);
        }
        let lineSize = this.getLineSize(line, fontSize);
        lineWidth = lineSize.width;
        lineHeight = lineSize.height;
      }
      else
      {
        let lineSize = this.getLineSize(" ", fontSize);
        lineHeight = lineSize.height;
      }
      // この行の描画位置を行の高さ分下にずらす
      cury += lineHeight;
      
      // 字間を加えたテキストのトータル幅
      let totalLetterSpacing = line.length > 0 ? letterSpacing * (line.length - 1) : 0;
      let totalTextWidth = lineWidth + totalLetterSpacing;

      // 字間情報、および揃え方向のオフセットを設定する
      let alignmentOffset = 0;
      if (this.layer.horizontalAlignment == 3 && line.length > 0) {
        // 均等揃えの場合は再計算
        letterSpacing = (this.layer.width - lineWidth) / (line.length - 1);
        letterSpacing *= 100 / this.layer.baseTextInfo.letterWidth;
        totalLetterSpacing = letterSpacing * (line.length - 1);
        totalTextWidth = lineWidth + totalLetterSpacing;
      }
      else if(this.layer.horizontalAlignment == 1)
      {
        // 中央揃え
        alignmentOffset = (this.layer.width - totalTextWidth) / 2;
      }
      else if(this.layer.horizontalAlignment == 2)
      {
        // 右揃え
        alignmentOffset = this.layer.width - totalTextWidth;
      }

      for(let cIdx = 0; cIdx < line.length; ++cIdx)
      {
        xs[cIdx] += letterSpacing * cIdx + alignmentOffset;
      }

      array.push({
        x: xs.length > 0 ? xs[0] : basex + alignmentOffset,
        xs: xs.join(" "),
        y: cury,
        width: totalTextWidth,
        height: lineHeight,
        text: line
      });

      // 改行する
      curx = basex;
      // 最終行以外は行間を開ける
      if (i < lines.length - 1)
        cury += (lineHeight * (this.layer.lineSpacing - 100)) / 100;
    }

    if (this.layer.verticalAlignment > 0) {
      // 縦方向揃え処理
      var dy = 0;
      if (this.layer.verticalAlignment == 1) {
        // 中央揃え
        dy = (this.layer.y + this.layer.height - cury) / 2;
      } else if (this.layer.verticalAlignment == 2) {
        // 下揃え
        dy = this.layer.y + this.layer.height - cury;
      }
      for (var i = 0; i < array.length; ++i) {
        array[i].y += dy;
      }
    }

    this.lineInfoArray = array;
  }

  private calcUnderLineRectFromLineInfo(info: {
    x: number;
    y: number;
    width: number;
    height: number;
    dx: string;
    text: string;
  }) {
    var x = info.x;
    var y =
      info.y +
      this.getFontSizeMm() *
        SimpleTextLayerDrawerB.UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT;
    var width = info.width;
    var height = this.underlineHeight;
    return { x: x, y: y, width: width, height: height };
  }

  private get fontSize() {
    return this.getFontSizeMm() + "px";
  }

  private getFontFamily(): string {
    var fontManager: FontManager = this.$store.getters.fontManager;
    var family = fontManager.getSimpleTextFontFamilyName(
      this.layer.baseTextInfo.fontId,
      this.isRendering && !this.isRenderingOnClient,
      this.isRenderingOnClient
    );
    return family;
  }

  private get fontStyle() {
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-weight": this.getFontWeight(),
      "font-style": this.getFontStyle(),
      fill: this.layer.baseTextInfo.textColor.hex,
      "white-space": "pre"
    };

    return style;
  }

  private get shadowFontStyle() {
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-weight": this.getFontWeight(),
      "font-style": this.getFontStyle(),
      fill: this.layer.baseTextInfo.shadowColor.hex,
      "white-space": "pre"
    };

    return style;
  }

  private shiftShadowY(y : number)
  {
    let distance = (this.getFontSizeMm() * 2 * this.layer.baseTextInfo.shadowDistance) / 100;
    let radian = (this.layer.baseTextInfo.shadowRotate * Math.PI) / 180;
    return y + distance * Math.sin(radian);
  }

  private shiftShadowXs(xs : string)
  {
    let xsarray = xs.split(' ');
    let shadowxs : Array<number> = [];
    let distance = (this.getFontSizeMm() * 2 * this.layer.baseTextInfo.shadowDistance) / 100;
    let radian = (this.layer.baseTextInfo.shadowRotate * Math.PI) / 180;
    for(let x of xsarray)
    {
      shadowxs.push(Number(x) + distance * Math.cos(radian));
    }
    return shadowxs.join(' ');
  }

  private get shadowBlueId() {
    return "shadow_blur_" + this.uuid;
  }

  private get shadowDiviation() {
    return (0.8 * this.layer.baseTextInfo.shadowBlur) / 100;
  }

  private get shadowOpacity() {
    return this.layer.baseTextInfo.shadowIntensity / 100;
  }

  private get outlineFontStyle() {
    var outlineThickness =
      (this.getFontSizeMm() * this.layer.baseTextInfo.outlineThickness) / 750;
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-weight": this.getFontWeight(),
      "font-style": this.getFontStyle(),
      fill: "none",
      stroke: this.layer.baseTextInfo.outlineColor.hex,
      "stroke-width": outlineThickness,
      "stroke-linejoin": "round",
      "white-space": "pre"
    };

    return style;
  }

  private get outlineOpacity() {
    return this.layer.baseTextInfo.outlineIntensity / 100;
  }

  private getFontWeight(): string {
    return SimpleTextLayerHelper.getFontWeight(
      this.layer.baseTextInfo.fontId,
      this.layer.baseTextInfo.bold,
      this.$store.getters.fontManager,
      this.isRendering,
      this.isRenderingOnClient
    );
  }

  private getFontStyle(): string {
    return this.layer.baseTextInfo.italic ? "italic" : "normal";
  }

  private get transform() {
    var transform = "";

    // オフセット
    transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
    // スケール
    transform += "scale(" + this.scale + " " + this.scale + "),";
    transform += "translate(" + this.layer.x + " " + this.layer.y + "),";
    // 回転を適用する
    transform += "rotate(" + this.layer.rotate + "),";
    // 幅・高さによる反転を適用する
    transform +=
      "scale(" +
      (this.layer.width < 0 ? -1 : 1) +
      " " +
      (this.layer.height < 0 ? -1 : 1) +
      "),";
    // 文字横幅を適用する
    transform +=
      "scale(" + this.layer.baseTextInfo.letterWidth / 100 + " " + 1 + "),";
    transform += "translate(" + -this.layer.x + " " + -this.layer.y + ")";

    return transform;
  }

  private get caretTransform() {
    var transform = "";

    // オフセット
    transform += "translate(" + this.offsetX + " " + this.offsetY + "),";

    transform +=
      "translate(" +
      this.layer.x * this.scale +
      " " +
      this.layer.y * this.scale +
      "),";
    // 回転を適用する
    transform += "rotate(" + this.layer.rotate + "),";
    // 幅・高さによる反転を適用する
    transform +=
      "scale(" +
      (this.layer.width < 0 ? -1 : 1) +
      " " +
      (this.layer.height < 0 ? -1 : 1) +
      "),";
    transform +=
      "translate(" +
      -this.layer.x * this.scale +
      " " +
      -this.layer.y * this.scale +
      ")";

    return transform;
  }

  private get rectTransform() {
    var transform = "";

    // オフセット
    transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
    // スケール
    transform += "scale(" + this.scale + " " + this.scale + "),";
    transform += "translate(" + this.layer.x + " " + this.layer.y + "),";
    // 回転を適用する
    transform += "rotate(" + this.layer.rotate + "),";
    // 幅・高さによる反転を適用する
    transform +=
      "scale(" +
      (this.layer.width < 0 ? -1 : 1) +
      " " +
      (this.layer.height < 0 ? -1 : 1) +
      "),";
    transform += "translate(" + -this.layer.x + " " + -this.layer.y + ")";

    return transform;
  }

  // キャレットを表示するか
  private get charetVisible() {
    // レンダリング中表示しない
    if (this.isRendering) {
      return false;
    }
    // エディット対象でなければ表示しない
    if (!this.isInEditor) {
      return false;
    }

    return (
      this.layer.inEdit && this.layer.startPosition == this.layer.endPosition
    );
  }
  private get caretPosition() {
    // const p0 = performance.now();
    var rectArray = SimpleTextLayerHelper.getRenderingTextRectArray(
      this.layer,
      this.$store.getters.fontManager,
      this.layer.startPosition,
      this.layer.startPosition + 1,
      false,
      this.textSizeCache,
      SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
    );
    if (rectArray.length == 0) {
      // console.warn('a', performance.now() - p0);
      return { x1: 0, y1: 0, x2: 0, y2: 0 };
    }
    var rect = rectArray[0].rect;
    var charetPos = {
      x1: rect.x,
      y1: rect.y,
      x2: rect.x,
      y2: rect.y + rect.height
    };
    if (Math.abs(charetPos.x1 - this.layer.x) < 0.2) {
      charetPos.x1 = charetPos.x2 = this.layer.x + 0.2;
    }
    if (Math.abs(charetPos.x1 - (this.layer.x + this.layer.width)) < 0.2) {
      charetPos.x1 = charetPos.x2 = this.layer.x + this.layer.width - 0.2;
    }
    // console.warn('a', performance.now() - p0);
    return {
      x1: charetPos.x1 * this.scale,
      y1: charetPos.y1 * this.scale,
      x2: charetPos.x2 * this.scale,
      y2: charetPos.y2 * this.scale
    };
  }

  // 選択を表示するか
  private get selectionVisible() {
    // レンダリング中表示しない
    if (this.isRendering) {
      return false;
    }
    // エディット対象でなければ表示しない
    if (!this.isInEditor) {
      return false;
    }

    return (
      this.layer.inEdit && this.layer.startPosition != this.layer.endPosition
    );
  }

  // 選択領域
  private get selectionRectArray() {
    var start = Math.min(this.layer.startPosition, this.layer.endPosition);
    var end = Math.max(this.layer.startPosition, this.layer.endPosition);
    return SimpleTextLayerHelper.getRenderingTextRectArray(
      this.layer,
      this.$store.getters.fontManager,
      start,
      end,
      false,
      this.textSizeCache,
      SimpleTextLayerDrawerB.CALC_BASE_FONT_SIZE
    );
  }

  private get underlineHeight() {
    return (
      this.getFontSizeMm() *
      SimpleTextLayerDrawerB.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT
    );
  }
}
